import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Box } from '@applyboard/ui-components';
import SingleSelectForm from "./SingleSelectForm";
import GradeConversionInfo from "./GradeConversionInfo";
function LetterGradeForm(_ref) {
  var id = _ref.id,
    formValidated = _ref.formValidated,
    letterGrades = _ref.letterGrades,
    grade = _ref.grade,
    onSubmit = _ref.onSubmit;
  var options = React.useMemo(function () {
    return letterGrades.map(function (letterGrade) {
      return {
        label: letterGrade.name,
        value: letterGrade.name
      };
    });
  }, [letterGrades]);
  function handleSubmit(value) {
    onSubmit(value);
  }
  return /*#__PURE__*/React.createElement(Box, {
    pb: "32px"
  }, /*#__PURE__*/React.createElement(SingleSelectForm, {
    defaultValue: grade,
    formValidated: formValidated,
    id: id,
    label: "Grading average",
    options: options,
    onSubmit: handleSubmit
  }), /*#__PURE__*/React.createElement(GradeConversionInfo, null));
}
export default LetterGradeForm;